import React from "react";

import withStyles from '@mui/styles/withStyles';
import classnames from "classnames";
import { useTranslation } from "react-i18next";

import { capitalizeFirstLetterAllWorlds } from "../../../util/capitalizeFirstLetter";
import { FileStatus } from "../../../util/enums";

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  classes?: any;
  className?: string;
};

const styles = () =>
  ({
    customBadge: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: (props: { textColor?: string; backgroundColor?: string }) =>
        props?.backgroundColor,
      minWidth: "51px",
      padding: "6px 16px",
      height: "40px",
      borderRadius: "20px",
      whiteSpace: "nowrap",
    },
    textValue: {
      color: (props: { textColor?: string }) => props?.textColor,
      fontFamily: "Inter",
      fontSize: "10px",
      fontWeight: 600,
      lineHeight: "20px",
    },
  } as const);

const SimpleBadge = (props: Props) => {
  const { classes, value, className, dataCy } = props;

  return (
    <div className={classnames(classes.customBadge, className)}>
      <span className={classes.textValue} data-cy={dataCy}>
        {value}
      </span>
    </div>
  );
};

const StyledBadge = withStyles(styles)(SimpleBadge);

export const BadgeImportFileStatus = (props: Props) => {
  const { value, className, dataCy } = props;
  const { t: translate } = useTranslation();

  const renderBadge = (
    backgroundColor: string,
    textColor: string,
    value?: string,
    formatWord = true
  ) => {
    if (value) {
      const formatted = formatWord ? capitalizeFirstLetterAllWorlds(value) : value;

      return (
        <StyledBadge
          dataCy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={formatted}
          className={className}
        />
      );
    }

    return <> </>;
  };

  switch (value) {
    case FileStatus.ERROR:
      return renderBadge("#FEE4E2", "#F04438", value);
    case FileStatus.UPLOADED:
      return renderBadge("#D1FADF", "#12B76A", value);
    default:
      return renderBadge("#e6fffd", "#00D0BD", value);
  }
};
